// extracted by mini-css-extract-plugin
module.exports = {"Row":"TestError_Row__X2ooX","Header":"TestError_Header__TtpnY","Icon":"TestError_Icon__OzJ7A","Error":"TestError_Error__eh5Cy"};